import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import i18n from "i18next";
import { ToastData } from "../components/ToastQueueProvider/ToastQueueProvider";

type CreateToast = (toast: Omit<ToastData, "id" | "show">) => void;

function errorToast(error: unknown, createToast: CreateToast) {
  const diagnostics = (error as any)?.response?.data?.issue?.[0]?.diagnostics;
  const message = diagnostics || (error as any)?.message || i18n.t("text.errorvalidatetext");
  createToast({
    title: i18n.t("text.errorvalidateheader"),
    icon: faTriangleExclamation,
    body: message,
  });
}

const ErrorManagementService = { errorToast };

export default ErrorManagementService;
